import React from "react";
import "./style.css";

/**
 * Consistent "no data yet" empty state — illustration + heading + optional
 * subtext. Used wherever a list/page has nothing to show instead of a
 * plain text line or a bare icon.
 */
const EmptyState = ({ title, message, image = "/images/No-data-cuate.png" }) => (
    <div className="empty-state-box">
        <img src={image} alt="" />
        {title && <h4>{title}</h4>}
        {message && <p>{message}</p>}
    </div>
);

export default EmptyState;
